export const isServer = typeof window === 'undefined';

export const isClient = typeof window === 'object';
export const DUMPERT_SETTINGS = '__DUMPERT_SETTINGS__';
export const defaultSettings = {
  /**
   * api services public urls
   */
  API_SERVICE_URL_USER: API_USER,
  API_SERVICE_URL_COMMENTS: API_COMMENTS,
  API_SERVICE_URL_POST: API_POST,
  API_SERVICE_URL_DUMPERT: API_DUMPERT,
  API_SERVICE_URL_UPLOAD: API_UPLOAD,

  /**
   * api services cluster internal urls
   */
  API_SERVICE_INTERNAL_URL_DUMPERT: null,
  API_SERVICE_INTERNAL_URL_COMMENTS: null,
  API_SERVICE_INTERNAL_URL_USER: null,
  API_SERVICE_INTERNAL_URL_POST: null,

  /**
   * ? comment me
   */
  ADMIN_HOST_URL: ADMIN_HOST,
  COMMENTS_HOST_URL: COMMENTS_HOST,
  RECAPTCHA_SITE_KEY: '6LcFKrkqAAAAALndXrk8VRND6ovUSCQuRZtnSh4F',

  /**
   * firebase auth configuration
   */
  AUTH_API_KEY: 'AIzaSyDlsTplscGUvKuUP1iWljt-ej5oxJWiGt4',
  AUTH_DOMAIN: 'dumpert-staging-c67e4.firebaseapp.com',
  AUTH_APP_ID: '1:964034364480:web:eaf36f477510ae80e88ba5',

  /**
   * Third party scripts
   */
  DIDOMI_API_KEY: DIDOMI_KEY,

  // https://shared.mediahuis.be/ka-ching/dumpert/ka-ching.umd.js
  ADS_KACHING_SCRIPT: 'https://previewshared.mediahuis.be/ka-ching/dumpert/ka-ching.umd.dev.js',

  // https://shared.mediahuis.be/cxense/cxense.dumpert.min.js
  ADS_CXENSE_SCRIPT: 'https://previewshared.mediahuis.be/cxense/cxense.dumpert.js',

  ADS_USE_PREVIEW_AD_UNIT: false,

  PLAYER_SCRIPT_1: '//imasdk.googleapis.com/js/sdkloader/ima3.js',

  PLAYER_SCRIPT_2: 'https://player-preview.agnoplay.com/static/agnoplay/js/agnoplay.js',

  // for A/B testing multiple comma separated values picked up randomly
  PLAYER_BRANDS: 'dumpert',

  // Google Analytics 4
  GA_TRACKING_ID: 'G-VL0L47BWJ7',

  // Google tag manager
  GTM_CODE: 'GTM-M8QXJBL',

  /**
   * Cloudflare Image Optimization Feature flag
   */
  USE_CF_IMGOPT: true,

  /**
   * custom ads urls, no default value
   */
  ADS_NSFW_URL: '',
  ADS_NSFA_URL: '',
};

const runtimeSettings =
  typeof window === 'object' && window[DUMPERT_SETTINGS] ? window[DUMPERT_SETTINGS] : {};

const environmentSettings =
  typeof process === 'object'
    ? Object.keys(defaultSettings)
        .filter((key) => key in process.env)
        .reduce((acc, key) => ({ ...acc, [key]: process.env[key] }), {})
    : {};

export const settings = {
  ...defaultSettings,
  ...environmentSettings,
  ...runtimeSettings,
};
